module.exports = __webpack_public_path__ + "front/img/zzs01.1e80cc25.png";